import Swiper from 'swiper/bundle'

export default class IASwiper {
    /**
     * @param {String | HTMLElement} element HTML element or CSS class which initialize Swiper
     * @param {Object} [options] Object of Swiper options (https://swiperjs.com/swiper-api#parameters) + custom fullwidth property
     * @param {Boolean} [options.fullwidth] Set Swiper as a fullwidth slider or not
     * @param {Number|Boolean} [options.autoplay] Set Swiper autoplay delay in milliseconds. By default, autoplay is off
     * @param {Number} [options.itemPerSlide] How many items per view we want to show on desktop
     * @param {Number} [options.itemPerSlideMobile] How many items per view we want to show on mobile
     * @param {HTMLElement} [options.paginationElement] Set Swiper pagination wrapper element 
     * @param {Object} [options.breakpoints] Define Swiper breakpoint
     */
    constructor(element, options = {
        fullwidth: false,
        autoplay: false,
        itemPerSlide: 3,
        itemPerSlideMobile: 1
    }) {


        if (options.fullwidth && options.fullwidth === true) {
            element.classList.remove('alignwide', 'aligncenter')
            element.classList.add('alignfull')
        }

        let autoplay = (options.autoplay !== false && !isNaN(options.autoplay) && options.autoplay > 0 ? { delay: options.autoplay } : false);
        let itemPerSlide = options.fullwidth && options.fullwidth === true ? 1 : (
            options.itemPerSlide !== undefined ? options.itemPerSlide : (
                element.classList.contains('has-multiple-items-per-slide') ? parseInt(element.getAttribute('data-swiper-slides-per-view')) : 1
            )
        );
        let itemPerSlideMobile = itemPerSlide > 1 ? 1 : itemPerSlide;
        let navigation = {
            nextEl: element.querySelector('.swiper-button-next') || null,
            prevEl: element.querySelector('.swiper-button-prev') || null
        };

        let pagination = {
            el: options.paginationElement || element.querySelector('.swiper-pagination'),
            clickable: true,
            renderBullet: function (index, className) {
                return '<button class="' + className + '"></button>';
            }
        }

        let autoHeight = options.autoHeight && options.autoHeight === true ? true : false 

        let breakpoints = options.breakpoints || { 640: { slidesPerView: itemPerSlide, slidesPerGroup: itemPerSlide }}

        let swiperOptions = {
            slidesPerView: itemPerSlideMobile,
            slidesPerGroup: itemPerSlideMobile,
            autoplay,
            autoHeight,
            navigation,
            pagination,
            watchSlidesProgress: true,
            breakpoints
        }

        this.instance = new Swiper(element, swiperOptions)
    }
}